module.exports = __webpack_public_path__ + "img/weixin1-02.20525ac8.png";